import API_BASE_URL from '../config';

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('[NotificationServiceWorker] Registered successfully:', registration.scope);
      return registration;
    } catch (error) {
      console.error('[NotificationServiceWorker] Registration failed:', error);
    }
  }
  return null;
};

export const subscribeUserToPush = async (guestId = null, userId = null) => {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('[NotificationService] Permission denied by user');
      return;
    }

    const response = await fetch(`${API_BASE_URL}/chats/vapid-public-key`);
    const { publicKey } = await response.json();
    
    if (!publicKey) {
      console.warn('[NotificationService] VAPID public key not found');
      return;
    }

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey)
    });

    await fetch(`${API_BASE_URL}/chats/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        subscription,
        guestId,
        userId
      })
    });

    console.log('[NotificationService] Subscribed to push notifications');
  } catch (error) {
    console.error('[NotificationService] Subscription setup failed:', error);
  }
};
